import { IconCalendar } from '@tabler/icons-react';
import { useId } from 'react';
import * as Flowbite from 'flowbite-react';
import { getReplaceThemeProps } from 'utils/replaceTheme';
import { theme } from './theme';

type DateProps = Flowbite.DatepickerProps & {
    label?: string;
    onChange?: (date: Date | null) => void;
};

export const DateInput = ({
    label,
    value = new Date(),
    onChange = () => {},
    color = 'primary',
    ...props
}: DateProps) => {
    const inputId = useId();

    return (
        <div className="flex flex-col gap-2">
            <Flowbite.Label
                className="font-medium"
                color={color}
                htmlFor={inputId}
            >
                {label}
            </Flowbite.Label>

            <Flowbite.Datepicker
                {...getReplaceThemeProps(theme)}
                {...props}
                id={inputId}
                color={color}
                icon={({ ref, ...props }) => <IconCalendar {...props} />}
                value={value}
                onChange={onChange}
                showClearButton={false}
                showTodayButton={false}
            />
        </div>
    );
};
